import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { LoggerService } from '../services/logger.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  // Skip authentication for certain URLs
  const skipAuth = ['/assets/', '.json', 'login', 'logout'].some((pattern) =>
    req.url.includes(pattern)
  );

  if (skipAuth || !authService.isAuthenticated) {
    return next(req);
  }

  // Get access token and add to request
  return from(authService.getAccessToken()).pipe(
    switchMap((token) => {
      const authReq = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${token}`),
      });
      return next(authReq);
    }),
    catchError((error: unknown) => {
      inject(LoggerService).error('Auth interceptor error:', error);
      return throwError(() => new Error('Failed to acquire authentication token'));
    })
  );
};
